export class AskInput {
  message: string;
  wasSentByUserInputAction: boolean;
}
